import { ExcelDownloadBtn } from "components/Buttons/ExcelDownloadBtn";
import { ListDefault } from "components/ListDefault/ListDefault";
import { List, Wrapper } from "template/ListTemplate.style";
import PaymentWalletDetailList from "./PaymentWalletDetailList";
import paymentWalletColumn from "../paymentWalletColumn.json";
import PageHandler from "components/PageHandler/PageHandler";
import { useExcelDownload } from "hooks/excelDownload/useExcelDownload";
import { PAYMENT_WALLET_XLSX_DOWNLOAD } from "constants/xlsxDownloadConstant";
import { useMutationCustom } from "hooks/useMutationCustom";
import { useToastCustom } from "hooks/useToastCustom";
import { POST_PAYMENT_LIST } from "constants/pathConstant";
import { InfoWrapper } from "../PaymentWallet.style";
import { useState } from "react";
import EmptyScreen from "components/EmptyScreen/EmptyScreen";

// 결제 내역 :: 결제 내역 리스트 (http://localhost:3000/super/payment/wallet)
const PaymentWalletDetail = ({
  setPage,
  setSize,
  paymentWalletList,
  searchData,
  isSearch,
}) => {
  const toast = useToastCustom();
  const excelDownload = useExcelDownload();

  const [cancelBg, setCancelBg] = useState(false);

  const { mutate } = useMutationCustom(POST_PAYMENT_LIST);

  const handleExcelDownload = () => {
    if (!isSearch || !paymentWalletList.listCount) {
      toast("다운로드할 데이터가 없습니다", "error");
      return;
    }

    const data = {
      ...searchData,
      pageSize: paymentWalletList.listCount,
      currentPage: 1,
    };

    mutate(data, {
      onSuccess: (response) => {
        const excelData = {
          data: response.list,
          headers: PAYMENT_WALLET_XLSX_DOWNLOAD.header,
          fileName: PAYMENT_WALLET_XLSX_DOWNLOAD.filename,
        };

        excelDownload(excelData);
      },

      onError: () => {
        toast("전체 데이터 조회 실패", "error");
      },
    });
  };

  return (
    <Wrapper>
      <List.TitleContainer>
        <List.Text>월렛 결제내역 목록</List.Text>
        <List.BtnContainer>
          {/* 페이지 핸들러 */}
          <PageHandler setPage={setPage} setPageSize={setSize} />
          {/* 엑셀 다운로드 버튼 */}
          <ExcelDownloadBtn onClick={handleExcelDownload} />
        </List.BtnContainer>
      </List.TitleContainer>

      <List.Container>
        {!isSearch && <ListDefault text={"결제내역을"} />}
        {isSearch && !paymentWalletList.list.length && <EmptyScreen />}
        {isSearch && !!paymentWalletList.list.length && (
          <>
            <List.Content>
              {paymentWalletColumn.column.map((v, idx) => (
                <List.Row $ratio={v.ratio} key={idx}>
                  {v.title}
                </List.Row>
              ))}
            </List.Content>
            <InfoWrapper cancelBg={cancelBg}>
              {paymentWalletList.list.map((v, idx) => (
                <PaymentWalletDetailList
                  key={idx}
                  data={v}
                  setCancelBg={setCancelBg}
                />
              ))}
            </InfoWrapper>
          </>
        )}
      </List.Container>
    </Wrapper>
  );
};

export default PaymentWalletDetail;
